import Button, { BUTTON_VARIANTS } from "@shared/ui/Button";
import { Input } from "@shared/ui/Inputs";
import Toast, { TOAST_TYPES } from "@shared/ui/Toast";
import React from "react";
import { toast } from "react-toastify";

import { SignUpFormHeader, PasswordInput } from "./components";
import { useSignUp } from "./hooks";
import { SignUpFormProps } from "./types";

const SignUpForm: React.FC<SignUpFormProps> = (props) => {
  const {
    email,
    loading,
    showPassword,
    showConfirmPassword,
    messages,
    errors,
    watch,
    setValue,
    trigger,
    toggleShowPassword,
    toggleShowConfirmPassword,
    handleFormSubmit,
  } = useSignUp(props);

  const namespace = props.messageNamespace ?? "signup";
  const ns = messages?.login?.[namespace];

  const handleError = (error: Error) => {
    toast(<Toast message={error.message} type={TOAST_TYPES.ERROR} />, {
      closeButton: false,
    });
  };

  return (
    <div>
      <SignUpFormHeader title={ns?.title} subtitle={ns?.subtitle} />
      <form
        onSubmit={handleFormSubmit(undefined, handleError)}
        className="w-[411px]"
      >
        <Input
          value={email}
          keyId="email"
          label={ns?.emailLabel}
          errorMessage={errors?.email?.message}
          disabled={true}
          readOnly={true}
          wrapperClasses="mb-2xl"
        />

        <PasswordInput
          keyId="password"
          name="password"
          label={ns?.passwordLabel}
          value={watch("password") || ""}
          showPassword={showPassword}
          errorMessage={errors?.password?.message}
          hint={ns?.passwordRequirements}
          onChange={(e) => {
            setValue("password", e.target.value, { shouldValidate: true });
            trigger("confirmPassword");
          }}
          onToggleVisibility={toggleShowPassword}
        />

        <PasswordInput
          keyId="confirmPassword"
          name="confirmPassword"
          label={ns?.confirmPasswordLabel}
          value={watch("confirmPassword") || ""}
          showPassword={showConfirmPassword}
          errorMessage={errors?.confirmPassword?.message}
          hint={ns?.confirmPasswordHint}
          onChange={(e) =>
            setValue("confirmPassword", e.target.value, {
              shouldValidate: true,
            })
          }
          onToggleVisibility={toggleShowConfirmPassword}
        />

        <Button
          variant={loading ? BUTTON_VARIANTS.LOADING : BUTTON_VARIANTS.PRIMARY}
          fullWidth={true}
          text={loading ? ns?.loadingButton : ns?.continueButton}
          type="submit"
          disabled={
            loading ||
            !watch("password") ||
            !watch("confirmPassword") ||
            !!errors?.password ||
            !!errors?.confirmPassword
          }
        />
      </form>
    </div>
  );
};

export default SignUpForm;
